export const CHARGE_TYPES = [
    'per-reservation',
    'per-night',
    'per-accommodation',
    'per-accommodation-per-night',
    'per-guest',
    'per-guest-per-night',
    'quantity',
];
export const isValidChargeType = (chargeType) => CHARGE_TYPES.includes(chargeType);
// Addons with these charge types should be added to each item of the same room in the Shopping Cart
const VARIABLE_CHARGE_TYPES = [
    'per-accommodation',
    'per-accommodation-per-night',
    'per-guest',
    'per-guest-per-night',
];
export const isVariableChargeType = ({ chargeType, }) => VARIABLE_CHARGE_TYPES.includes(chargeType);
// Addons with these charge types should be added only once to the Shopping Cart
const FIXED_CHARGE_TYPES = ['per-reservation', 'per-night'];
export const isFixedChargeType = ({ chargeType }) => FIXED_CHARGE_TYPES.includes(chargeType);
